// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".img-shadow[data-v-35f60d86]{background-position:center;background-repeat:no-repeat;background-size:cover;position:absolute;inset:0;z-index:0;filter:blur(11px);opacity:.5;-webkit-mask-image:linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, black 100%);mask-image:linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, black 100%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
